type BootErrorProps = {
  title?: string
  message: string
  details?: string
}

export default function BootError({
  title = 'KILO could not start',
  message,
  details,
}: BootErrorProps) {
  const isProd = import.meta.env.PROD

  return (
    <div
      style={{
        minHeight: '100vh',
        margin: 0,
        padding: '2rem',
        background: 'var(--kilo-page)',
        color: 'var(--kilo-text)',
        fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
        lineHeight: 1.5,
      }}
    >
      <div
        style={{
          maxWidth: '32rem',
          margin: '0 auto',
          border: '1px solid var(--kilo-border)',
          borderRadius: '1rem',
          padding: '1.5rem',
          background: 'var(--kilo-card)',
        }}
      >
        <p style={{ margin: 0, fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--kilo-accent)' }}>
          KILO · Boot error
        </p>
        <h1 style={{ margin: '0.75rem 0 0', fontSize: '1.5rem' }}>{title}</h1>
        <p style={{ margin: '1rem 0 0', color: '#d4d4d8' }}>{message}</p>
        {details ? (
          <pre
            style={{
              marginTop: '1rem',
              padding: '0.75rem',
              borderRadius: '0.75rem',
              background: '#111',
              color: '#fca5a5',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: '0.85rem',
            }}
          >
            {details}
          </pre>
        ) : null}
        <ol style={{ margin: '1.25rem 0 0', paddingLeft: '1.25rem', color: '#a1a1aa' }}>
          {isProd ? (
            <>
              <li>Open Cloudflare Dashboard → Workers &amp; Pages → your KILO project</li>
              <li>Settings → Environment variables → add <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code> for <strong>Production</strong> and <strong>Preview</strong></li>
              <li>Deployments → Retry deployment (or push a new commit) — old deployments cannot pick up new vars</li>
              <li>Get values from Supabase → Project Settings → API</li>
            </>
          ) : (
            <>
              <li>Open the project folder: <code>~/projects/kilo-app</code></li>
              <li>Ensure <code>.env.local</code> contains <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code></li>
              <li>Restart the dev server: <code>npm run dev</code></li>
              <li>Open <code>http://localhost:5173/</code> in Chrome or Firefox</li>
            </>
          )}
        </ol>
      </div>
    </div>
  )
}
